module.exports = __webpack_public_path__ + "static/media/76gal05.1d3ab61f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/76gal/76gal05.jpg
// module id = 156
// module chunks = 0